import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import PickOption from "../types/pickOption";

interface PickerState {
  status: "idle" | "loading" | "failed";
  pickOptions: PickOption[];
}

const initialState: PickerState = {
  status: "idle",
  pickOptions: [],
};

const pickerSlice = createSlice({
  name: "picker",
  initialState,
  reducers: {
    resetPicker(state) {
      state.pickOptions = initialState.pickOptions;
    },
    setPickOptions(state, action: PayloadAction<PickOption[]>) {
      state.pickOptions = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { resetPicker, setPickOptions } = pickerSlice.actions;
export default pickerSlice.reducer;
